import theme from '../../theme';
import { styled } from '@mui/material/styles';

import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


export const ButtonSyetemMain = styled(Button)(({ theme }) => ({
  paddingRight: '16px',
  paddingLeft: '16px',
  color: '#fff',
  backgroundColor: theme.palette.system.main,
  '&:hover': {
    backgroundColor: theme.palette.system.dark,
  }
}))

export const ButtonGrey = styled(Button)(({ theme }) => ({
  paddingRight: '12px',
  paddingLeft: '12px',
  color: '#fff',
  backgroundColor: theme.palette.grey.w400,
  '&:hover': {
    backgroundColor: theme.palette.grey.w600,
  }
}))

export const ButtonMain = styled(Button)(({ theme }) => ({
  color: '#fff',
  alignItems: 'center',
  paddingRight: '16px',
  paddingLeft: '16px'
}))

export const ButtonBlueMain = styled(Button)(({theme}) => ({
  paddingRight: '16px',
  paddingLeft: '16px',
  color: '#fff',
  backgroundColor: theme.palette.facebook.main,
  '&:hover':{
    backgroundColor: theme.palette.facebook.dark,
  }
}))

export const ButtonOrangeMain = styled(Button)(({ theme }) => ({
  paddingRight: '16px',
  paddingLeft: '16px',
  color: '#fff',
  backgroundColor: theme.palette.google.main,
  '&:hover': {
    backgroundColor: theme.palette.google.dark,
  }
}))

export const ButtonGreenMain = styled(Button)(({ theme }) => ({
  paddingRight: '16px',
  paddingLeft: '16px',
  color: '#fff',
  backgroundColor: theme.palette.line.main,
  '&:hover': {
    backgroundColor: theme.palette.line.dark,
  }
}))

export const ButtonGreenOutline = styled(Button)(({ theme }) => ({
  color: theme.palette.line.main,
  border: 'none',
  '&:hover': {
    backgroundColor: theme.palette.line.main,
    color: '#fff',
  }
}))

